import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { paymentActions } from "../../redux/paymentSlice";
import { getSingleInvoice } from "../../redux/invoiceSlice";
import { Button, Modal, Input, message } from "antd";
import { CheckOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";

const InvoiceDetail = () => {
  const { id } = useParams(); // Get the invoice ID from the URL parameters
  const dispatch = useDispatch();
  const { selectedInvoice, loading, error } = useSelector(
    (state) => state.invoices
  );
  const [rejectedReason, setRejectedReason] = useState("");
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [selectedPaymentId, setSelectedPaymentId] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [status, setStatus] = useState(null);

  // Fetch the invoice details when the component mounts
  useEffect(() => {
    if (id) {
      dispatch(getSingleInvoice(id));
    }
  }, [dispatch, id]);

  const handleConfirmStatus = (paymentId) => {
    const payload = {
      id: paymentId,
      status: "Confirmed",
    };
    dispatch(paymentActions.updatePaymentStatus(payload))
      .unwrap()
      .then(() => {
        message.success("Payment confirmed successfully!");
        dispatch(paymentActions.getPayments());
        setImageUrl(null); // Close the slip modal after confirmation
      })
      .catch(() => {
        message.error("Failed to confirm payment.");
      });
  };

  const handleRejectClick = (paymentId) => {
    setSelectedPaymentId(paymentId);
    setIsRejectModalVisible(true);
  };

  const handleRejectPayment = () => {
    if (selectedPaymentId) {
      const payload = {
        id: selectedPaymentId,
        status: "Rejected",
        rejected_reason: rejectedReason,
      };
      dispatch(paymentActions.updatePaymentStatus(payload))
        .unwrap()
        .then(() => {
          message.success("Payment rejected successfully!");
          setIsRejectModalVisible(false);
          setRejectedReason(""); // Reset rejection reason
          setImageUrl(null); // Close the slip modal after rejection
          dispatch(paymentActions.getPayments());
        })
        .catch(() => {
          message.error("Failed to reject payment.");
        });
    }
  };

  const handleCancelReject = () => {
    setIsRejectModalVisible(false);
    setRejectedReason(""); // Reset rejection reason
  };

  const handleImageClick = (url, paymentId, status) => {
    setImageUrl(url);
    setSelectedPaymentId(paymentId);
    setStatus(status);
  };

  const handleImageModalClose = () => {
    setImageUrl(null);
  };

  console.log("selected invoice", selectedInvoice);
  return (
    <div className="p-8 rounded-md">
      <div className="p-8 bg-white">
        <h2 className="text-xl font-bold text-center mb-2">
          Society of Comfort SMD Awas Bayawasthapan Samiti
        </h2>
        <p className="text-center">Thaiba-14, Lalitpur</p>
        <div className="mt-8 text-sm font-mono border-gray-400 pb-2 mb-4">
          <div className="flex justify-between">
            <p>
              <strong>House No:</strong> {selectedInvoice?.house_number}
            </p>
            <p>
              <strong>UserName:</strong> {selectedInvoice?.user_name}
            </p>
            <p>Date: {selectedInvoice?.due_date}</p>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead>
              <tr className="bg-gray-100">
                <th className="py-2 px-4 border">S.no</th>
                <th className="py-2 px-4 border">Particular</th>
                <th className="py-2 px-4 border">Quantity</th>
                <th className="py-2 px-4 border">Rate</th>
                <th className="py-2 px-4 border">Total</th>
              </tr>
            </thead>
            <tbody>
              {selectedInvoice?.invoice_items &&
              selectedInvoice?.invoice_items.length > 0 ? (
                selectedInvoice?.invoice_items.map((item, index) => (
                  <tr key={index}>
                    <td className="py-2 px-4 border">{index + 1}</td>
                    <td className="py-2 px-4 border">{item.particular}</td>
                    <td className="py-2 px-4 border">{item.quantity}</td>
                    <td className="py-2 px-4 border">{item.rate}</td>
                    <td className="py-2 px-4 border">
                      {item.quantity * item.rate}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="py-2 px-4 border text-center">
                    No items found for this invoice.
                  </td>
                </tr>
              )}
              <tr className="bg-gray-100 font-bold">
                <td colSpan={4} className="py-2 px-4 border">
                  Amount Total
                </td>
                <td className="py-2 px-4 border">
                  {selectedInvoice?.total_amount}
                </td>
              </tr>
              <tr className="bg-gray-100 font-bold">
                <td colSpan={4} className="py-2 px-4 border">
                  Due Amount Total
                </td>
                <td className="py-2 px-4 border">
                  {selectedInvoice?.due_at_invoice}
                </td>
              </tr>
              <tr className="bg-gray-200 font-bold">
                <td colSpan={4} className="py-2 px-4 border">
                  Grand Total
                </td>
                <td className="py-2 px-4 border">
                  {Number(selectedInvoice?.total_amount) +
                    Number(selectedInvoice?.due_at_invoice)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex justify-between mt-8 mb-4">
        <h2 className="text-xl font-bold mb-2 mt-4">Payment Record</h2>
        {selectedInvoice?.remaining_amount > 0 ? (
          <Link
            to={`/dashboard/adminaddpayment/${selectedInvoice?.id}`}
            className="my-auto"
          >
            <Button
              type="default"
              className="bg-green-800 text-white hover:bg-green-600 px-4 py-2 rounded-xl"
              icon={<PlusOutlined />}
            >
              Add Payment
            </Button>
          </Link>
        ) : (
          <div></div>
        )}
      </div>
      <div className="flex flex-col gap-4 mt-8">
        {selectedInvoice?.payments.map((pay) => (
          <Link className="my-auto">
            <div
              className={`bg-white p-4 rounded-lg px-20 py-8 ${
                pay.status === "Pending" ? "border-red-400" : "border-green-400"
              }  border-l-[10px]`}
            >
              <div className="flex justify-between">
                <div>
                  <p className="text-gray-500">Id</p>
                  <p className="font-semibold mt-2">{pay.id}</p>
                </div>
                <div>
                  <p className="text-gray-500">Date</p>
                  <p className="font-semibold mt-2">{pay.date}</p>
                </div>
                <div>
                  <p className="text-gray-500">Invoice status</p>
                  <p className="font-semibold mt-2">{pay.status}</p>
                </div>
                <div>
                  <img src={pay.slip} />
                </div>
                <div>
                  <p className="text-gray-500">Amount</p>
                  <p className="font-semibold mt-2">{pay.amount}</p>
                </div>
                <div>
                  {pay.status === "Pending" && (
                    <>
                      <Button
                        type="primary"
                        icon={<CheckOutlined />}
                        onClick={() => handleConfirmStatus(pay?.id)}
                      />
                      <Button
                        danger
                        icon={<CloseOutlined />}
                        onClick={() => handleRejectClick(pay?.id)}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <Modal
        title="Reject Payment"
        visible={isRejectModalVisible}
        onOk={handleRejectPayment}
        onCancel={handleCancelReject}
      >
        <Input.TextArea
          rows={4}
          value={rejectedReason}
          onChange={(e) => setRejectedReason(e.target.value)}
          placeholder="Enter rejection reason"
        />
      </Modal>
      <Modal
        visible={!!imageUrl}
        onCancel={handleImageModalClose}
        footer={
          status === "Pending" && (
            <>
              <Button
                type="primary"
                icon={<CheckOutlined />}
                onClick={() => handleConfirmStatus(selectedPaymentId)}
              />
              <Button
                danger
                icon={<CloseOutlined />}
                onClick={() => handleRejectClick(selectedPaymentId)}
              />
            </>
          )
        }
        centered
      >
        {imageUrl && (
          <img src={imageUrl} alt="Slip Preview" className="w-full" />
        )}
      </Modal>
    </div>
  );
};

export default InvoiceDetail;
